import { notify } from 'react-notify-toast'
import history from '../history'

import { providersRef } from '../database'
import { providersConstants } from '../constants'

export let providersSnap

export function loadProviders() {
  return (dispatch) => {
    dispatch(loadingProviders())
    providersSnap = providersRef.onSnapshot(
      (result) => {
        result.docChanges().forEach((change) => {
          const data = change.doc.data()
          const id = change.doc.id
          if (change.type === 'added') {
            dispatch(updateProvider({ id, ...data }))
          }
          if (change.type === 'modified') {
            dispatch(updateProvider({ id, ...data }))
          }
          if (change.type === 'removed') {
            dispatch(removeProvider({ id, ...data }))
          }
        })
      },
      (error) => {
        console.log(error)
        dispatch(loadingProvidersError('Error: ' + error))
      }
    )
  }
}

function loadingProviders() {
  return {
    type: providersConstants.LOADING_PROVIDERS
  }
}

function loadingProvidersError(payload) {
  return {
    type: providersConstants.LOADING_PROVIDERS_ERROR,
    payload
  }
}

function updateProvider(payload) {
  return {
    type: providersConstants.UPDATE_PROVIDER,
    payload
  }
}

function removeProvider(payload) {
  return {
    type: providersConstants.REMOVE_PROVIDER,
    payload
  }
}

export function saveProvider(id, payload, redirect = true) {
  return (dispatch) => {
    dispatch(ajaxCall())
    if (id === null) {
      providersRef
        .add(payload)
        .then((res) => {
          dispatch(ajaxCallSuccess())
          notify.show('salvato con successo', 'success', 3000)
          if (redirect) history.push(`/registry`)
        })
        .catch((error) => {
          if (error.response !== undefined) {
            dispatch(ajaxCallFailure(error.response.statusText))
          } else {
            dispatch(ajaxCallFailure(error.message))
          }
        })
    } else {
      providersRef
        .doc(id)
        .update({ ...payload })
        .then(() => {
          dispatch(ajaxCallSuccess())
          notify.show('salvato con successo', 'success', 3000)
          if (redirect) history.push(`/registry`)
        })
        .catch((error) => {
          if (error.response !== undefined) {
            dispatch(ajaxCallFailure(error.response.statusText))
          } else {
            dispatch(ajaxCallFailure(error.message))
          }
        })
    }
  }
}

function ajaxCall() {
  return {
    type: providersConstants.PROVIDER_AJAX_CALL
  }
}

function ajaxCallSuccess() {
  return {
    type: providersConstants.PROVIDER_AJAX_SUCCESS
  }
}

function ajaxCallFailure(payload) {
  return {
    type: providersConstants.PROVIDER_AJAX_FAILURE,
    payload
  }
}
